"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupUNUSED_ROLE_BINDING = void 0;

var validator_id_1 = require("../../../validator-id");

var categories_1 = require("../../categories");

function setupUNUSED_ROLE_BINDING(builder) {
  builder.validator(validator_id_1.ValidatorID.UNUSED_ROLE_BINDING).category(categories_1.ValidatorCategory.RBAC).title('Unused RoleBinding').description("RoleBinding grants Role permissions to ServiceAccounts or Users.\n\nThis validator detects RoleBindings that are not associated with\nany application workloads.\n").affected("RoleBinding").affected("ClusterRoleBinding").example("\napiVersion: rbac.authorization.k8s.io/v1\nkind: RoleBinding\nmetadata:\n  name: read-pods\nsubjects:\n- kind: ServiceAccount\n  name: backend\n...\n").resolution("\nExamine applications within the namespace and determine if ServiceAccount in\nRoleBinding is supposed to be used in those workloads.").resolution("\nMake necessary naming corrections in RoleBinding ServiceAccount subject references.\n").resolution("\nIf the RoleBinding is indeed unused, it may need to be just removed.\n").externalLink('https://kubernetes.io/docs/reference/access-authn-authz/rbac/#referring-to-subjects');
}

exports.setupUNUSED_ROLE_BINDING = setupUNUSED_ROLE_BINDING;